import { render, staticRenderFns } from "./ProductBulkImportModal.vue?vue&type=template&id=79565d02&"
import script from "./ProductBulkImportModal.vue?vue&type=script&lang=js&"
export * from "./ProductBulkImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports